import { Chip } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils';
import { QuizImage } from './QuizImage';
import { type HintType } from './types';

/**
 * QuizHint - 힌트 표시 컴포넌트
 * EditableQuizCard/EditableHint/HintContent.tsx와 일치
 * @component
 */

interface QuizHintProps {
  type: HintType;
  value: string;
  className?: string;
}
const HintIndicatorChip = ({
  className
}: {
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <Chip size="sm" className={cn('rounded-xl border border-alternative px-xs py-3xs text-body-sm-semibold', className)} data-sentry-element="Chip" data-sentry-component="HintIndicatorChip" data-sentry-source-file="QuizHint.tsx">
      {t('common:quizItem.hint.title')}
    </Chip>;
};
export const QuizHint = ({
  type,
  value,
  className
}: QuizHintProps) => {
  if (!value) {
    return null;
  }
  return <div className={cn('block pb-xs', className)} data-sentry-component="QuizHint" data-sentry-source-file="QuizHint.tsx">
      <div className="flex items-center gap-xs">
        <HintIndicatorChip className="shrink-0" data-sentry-element="HintIndicatorChip" data-sentry-source-file="QuizHint.tsx" />
        <div className="grow">
          {type === 'text' && <span className="block break-all text-body-lg-medium text-alternative">
              {value}
            </span>}
          {type === 'image' && value && <QuizImage.Container className="size-[62px]" onClick={() => imageDetailModal.open(value)}>
              <QuizImage.Thumbnail src={value} alt="hint" />
            </QuizImage.Container>}
          {type === 'youtube' && value && <a href={value} target="_blank" rel="noopener noreferrer" className="break-all text-body-lg-medium text-link">
              {value}
            </a>}
        </div>
      </div>
    </div>;
};